import { render, staticRenderFns } from "./DeviceDataBatches_Virtual.vue?vue&type=template&id=13fddd71"
import script from "./DeviceDataBatches_Virtual.vue?vue&type=script&lang=js"
export * from "./DeviceDataBatches_Virtual.vue?vue&type=script&lang=js"
import style0 from "./DeviceDataBatches_Virtual.vue?vue&type=style&index=0&id=13fddd71&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports